import { User } from '@/support/user';
import router from '@/router';
import axios from 'axios';
import Cove from '@ctrack/cove';
import appMessages from '@/i18n';

// ==============================================
// user module
// ==============================================
const user = {
  namespaced: true,
  state: {
    user: new User()
  },
  getters: {
    isLoggedIn (state) {
      return state.user.isLoggedIn;
    },
    displayName (state) {
      return state.user.displayName;
    },
    hasAccess: (state) => {return (componentID, permissionLevel) => {
      return state.user.hasAccess(componentID, permissionLevel);
    };}
  },
  mutations: {
    login (state, payload = {})
    {
      state.user.login(payload);
      state.user.setAccessToken((Math.random()).toString(16).slice(2));
    },
    logout (state)
    {
      state.user.logout();
      Cove.notify({ color: 'success', message: appMessages.t('logout.success') });
      router.push({ name: 'login' });
    },
    recover (state, payload = {})
    {
      state.user.login(payload);
    }
  },
  actions: {
    login (context) {
      return context.dispatch('_loadPermissions').then((permissions) => {
        context.commit('login', { displayName: appMessages.t('app.user'), permissions });
        let nextURL = window.localStorage.getItem('nextURL');
        if (nextURL !== undefined && nextURL !== null && nextURL.length > 0)
        {
          router.push({ path: nextURL });
          window.localStorage.removeItem('nextURL');
        }
        else
        {
          router.push({ name: 'home' });
        }
      });
    },
    recover (context) {
      return context.dispatch('_loadPermissions').then((permissions) => {
        context.commit('recover', { displayName: appMessages.t('app.user'), permissions });
      });
    },
    _loadPermissions () {
      let url = Cove.getAPI({ name: 'api.userPermissions' });
      let promise = new Promise((resolve) => {
        axios.get(url).then((response) => {
          let permissions = {};
          response.data.forEach((permission) => {
            permissions[permission.componentID] = permission.permissionLevel;
          });

          resolve(permissions);
        });
      });

      return promise;
    }
  }
};

export default {
  user
};
